import React from "react";
import {useInvestAssistantContext} from "./ContextType";
import {Slide} from "@mui/material";

export function Slider(props: { children: any, nr: number }) {
    const {slideDirection, currentStage} = useInvestAssistantContext();

    return <Slide
        direction={props.nr >= currentStage ? 'left' : 'right'}
        in={props.nr == currentStage}
        mountOnEnter
        unmountOnExit
        timeout={{enter: 400, exit: 250}}
        easing={{
            enter: 'cubic-bezier(0.16, 1, 0.3, 1)',
            exit: 'cubic-bezier(0.4, 0, 1, 1)',
        }}
    >
        <div style={{width: '100%'}}>
            {props.children}
        </div>
    </Slide>
}
